import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import { FaFileAlt } from 'react-icons/fa';
import axios from 'axios';
import politicaImg from '../assets/POLITICADECALIDADSIBUS.jpeg';
import '../styles/politicaVisionCard.css';

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:4005' : '');

const PoliticaVisionCard = ({ userData }) => {
  const [politicaActiva, setPoliticaActiva] = useState(null);
  const [firmaUsuario, setFirmaUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userData) return;
    
    const cargarPolitica = async () => {
      try {
        const token = localStorage.getItem('token');
        
        // Obtener política activa
        const response = await axios.get(`${API_URL}/api/politicas/version-activa`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data.success && response.data.data) {
          const politica = response.data.data;
          setPoliticaActiva(politica);
          
          // Verificar si el usuario firmó (enviar politicaId en el body)
          const firmaResponse = await axios.post(
            `${API_URL}/api/politicas/verificar-firma`,
            { politicaId: politica.id },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          
          if (firmaResponse.data.success && firmaResponse.data.firma) {
            setFirmaUsuario(firmaResponse.data.firma);
          }
        }
      } catch (error) {
        console.error('Error cargando política:', error);
      } finally {
        setLoading(false);
      }
    };

    cargarPolitica();
  }, [userData]);

  if (loading || !politicaActiva || !firmaUsuario) {
    return null; // No mostrar nada si no hay política activa o no firmó
  }

  const handleVerPDF = () => {
    const token = localStorage.getItem('token');
    // Siempre mostrar el PDF original de la política (sin firma)
    const url = `${API_URL}/api/politicas/documento/${politicaActiva.id}?token=${token}`;
    window.open(url, '_blank');
  };

  return (
    <Card className="politica-vision-card">
      <div className="politica-background" style={{ backgroundImage: `url(${politicaImg})` }}>
        <div className="politica-overlay"></div>
        <Card.Body className="politica-content">
          <div className="politica-header">
            <FaFileAlt className="politica-icon" />
            <h4 className="politica-title">Política, Seguridad y Visión</h4>
          </div>
          <p className="politica-subtitle">
            {politicaActiva.titulo} - Versión {politicaActiva.version}
          </p>
          <Button 
            variant="light" 
            className="politica-btn"
            onClick={handleVerPDF}
          >
            Ver Documento
          </Button>
        </Card.Body>
      </div>
    </Card>
  );
};

export default PoliticaVisionCard;
